import { useMemo } from 'react';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import {
  togglePinnedFiltersState,
  selectProcurementPinnedFilters,
} from '@store';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import PersonIcon from '@mui/icons-material/Person';
import { PROCUREMENT_ORDERS_FIELDS_MAPPER } from 'components/procurement/constants';

const useProcurementFilterConfig = ({ suppliers }) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const pinnedFilters = useSelector(selectProcurementPinnedFilters);

  const filterCategories = useMemo(
    () => [
      {
        id: 'stage',
        label: 'Stage',
        icon: RadioButtonUncheckedIcon,
        options:
          [
            { value: '', text: 'All' },
            ...PROCUREMENT_ORDERS_FIELDS_MAPPER.stage.options.map((option) => ({
              value: option.apiKey,
              text: option.text,
            })),
          ] || [],
        multiSelect: false,
      },
      {
        id: 'supplier',
        label: 'Supplier',
        icon: PersonIcon,
        options: [{ value: '', text: 'All' }, ...suppliers] || [],
        multiSelect: false,
      },
    ],
    [suppliers]
  );
  const handlePinnedFilterSelect = (pinnedFilter) => {
    dispatch(togglePinnedFiltersState({ board: 'procurement', pinnedFilter }));
  };

  const currentFilters = useMemo(() => {
    const parseQueryValue = (value) => {
      if (!value) return [];
      if (typeof value === 'string') {
        return value.split(',').filter(Boolean);
      }
      return Array.isArray(value) ? value : [];
    };

    return {
      stage: parseQueryValue(router.query.stage),
      supplier: parseQueryValue(router.query.supplier),
    };
  }, [router.query]);

  return {
    filterCategories,
    currentFilters,
    handlePinnedFilterSelect,
    pinnedFilters,
    supportPinnedFilters: true,
  };
};

export default useProcurementFilterConfig;
